/* eslint-disable no-param-reassign */
import { ErrorMessage } from '@hookform/error-message';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import Button from '@/components/elements/Button/BaseButton';
import Input from '@/components/elements/Form/Input';
import { BetDataList, BetDetail } from '@/modelTypes';

import {
  Form,
  FundSettingWrapper,
  HundredYenSpan,
  SettingName,
  ValidMsg,
} from '../style';

interface BulkFundSettingProps {
  raceId: string;
  itemId?: string;
  setBetDataList: React.Dispatch<React.SetStateAction<BetDataList>>;
}

interface FormInput {
  fund: string;
}

const VALID_MSG1 = '金額一括指定は100円以上で入力してください。';
const VALID_MSG2 = '金額一括指定は半角数字のみで入力してください。';

const BulkFundSetting: React.FC<BulkFundSettingProps> = ({
  raceId,
  itemId,
  setBetDataList,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>({
    reValidateMode: 'onSubmit',
  });

  const setCount = (betDetail: BetDetail, fund: number) => {
    betDetail.tickets.forEach(ticket => {
      if (!ticket.isRemoved) {
        ticket.count = fund;
      }
    });
  };

  const setFund = (data: FormInput) => {
    setBetDataList(prev => {
      const temp = { ...prev };
      if (itemId) {
        setCount(temp[raceId][itemId], Number(data.fund));
      } else {
        Object.keys(temp[raceId]).forEach(key => {
          setCount(temp[raceId][key], Number(data.fund));
        });
      }
      return temp;
    });
    toast.success('金額一括指定がセットされました');
  };

  return (
    <>
      <FundSettingWrapper>
        <SettingName>金額一括指定</SettingName>
        <Form onSubmit={handleSubmit(setFund)}>
          <Input
            type="tel"
            maxLength={3}
            width="65px"
            height="40px"
            textAlign="right"
            hasError={Boolean(errors.fund)}
            {...register('fund', {
              required: {
                value: true,
                message: VALID_MSG1,
              },
              min: {
                value: 1,
                message: VALID_MSG1,
              },
              pattern: {
                value: /^\d+$/,
                message: VALID_MSG2,
              },
            })}
          />
          <HundredYenSpan>00円</HundredYenSpan>
          <Button
            bgColor="primary"
            size="xs"
            width="60px"
            height="40px"
            radius="m"
            type="submit"
            fontWeight="bold"
          >
            セット
          </Button>
        </Form>
      </FundSettingWrapper>
      <ErrorMessage
        errors={errors}
        name="fund"
        render={({ message }) => <ValidMsg>{message}</ValidMsg>}
      />
    </>
  );
};

export default BulkFundSetting;
